import { useEffect, useState } from "react";
import { supabase } from "../supabase/supabaseClient";
import ResetPasswordForm from "./ResetPasswordForm";

export default function ResetPasswordPage() {
  const [ready, setReady] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      // 0) 기존 세션 있으면 통과
      const { data: { session } } = await supabase.auth.getSession();
      if (session) { setReady(true); return; }

      // 1) PKCE: ?code=...
      const url = new URL(window.location.href);
      const code = url.searchParams.get("code");
      if (code) {
        const { error } = await supabase.auth.exchangeCodeForSession(code);
        if (error) setErr(error.message);
        setReady(true);
        return;
      }

      // 2) 토큰 해시: #access_token=...&refresh_token=...
      const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
      const access_token = hash.get("access_token");
      const refresh_token = hash.get("refresh_token");
      if (access_token && refresh_token) {
        const { error } = await supabase.auth.setSession({ access_token, refresh_token });
        if (error) setErr(error.message);
        setReady(true);
        return;
      }

      // 3) 둘 다 없으면 잘못 들어온 링크
      setErr("비밀번호 재설정 링크가 올바르지 않거나 만료되었습니다. 이메일에서 링크를 다시 열어주세요.");
      setReady(true);
    })();
  }, []);

  if (!ready) return <div style={{ padding: 24 }}>세션 확인 중…</div>;
  if (err) return <div style={{ padding: 24, color: "red" }}>{err}</div>;

  // 세션 복원 성공 → 폼 렌더
  return <ResetPasswordForm />;
}
